export declare enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
export const transformSortToWQL = (
  sort: { fieldName: string; order: 'asc' | 'desc' }[] | undefined,
) => {
  return (
    sort?.map((sortField) => ({
      fieldName: sortField.fieldName,
      order: sortField.order.toUpperCase() as SortOrder,
    })) ?? []
  );
};
